import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';
import { Assistant } from '@vendasta/protos/ai_assistants/v1alpha1';
import { AiAssistantService } from '../../core/services/ai-assistant.service';
import { NAMESPACE_CONFIG_TOKEN } from '../../core/tokens';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, map, of, switchMap } from 'rxjs';

@Component({
  selector: 'ai-testing-page',

  imports: [
    GalaxyPageModule,
    GalaxyLoadingSpinnerModule,
    GalaxyEmptyStateModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    AiAssistantI18nModule,
  ],
  templateUrl: './ai-testing-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ai-testing-page.component.scss',
})
export class AiTestingPageComponent {
  private readonly aiAssistantService = inject(AiAssistantService);
  private readonly namespaceConfig$ = inject(NAMESPACE_CONFIG_TOKEN);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  private readonly assistants$ = this.namespaceConfig$.pipe(
    switchMap((config) => this.aiAssistantService.listAllAssistants(config.namespace)),
    catchError(() => of([])),
  );

  protected readonly loading = toSignal(this.assistants$.pipe(map(() => false)), { initialValue: true });

  protected readonly assistants = toSignal(this.assistants$, { initialValue: [] as Partial<Assistant>[] });

  selectAssistant(assistant: Partial<Assistant>): void {
    this.router.navigate([assistant.id], { relativeTo: this.route });
  }
}
